import { useState } from 'react';
import { useOverlayContext } from '~/contexts';
import { handlePromise } from '~/infra/utils';
import { useStoreActions } from '~/store/store-context';
export function useUpdateDraft() {
    const { api } = useStoreActions();
    const { showErrorToast } = useOverlayContext();
    const [loading, setLoading] = useState(false);
    return {
        loading,
        async updateDraft (param) {
            let { newDraft, onSuccess, onStartLoader, onStopLoader } = param;
            onStartLoader && onStartLoader();
            setLoading(true);
            const result = await handlePromise(api.draft.save(newDraft.toDTO()));
            onStopLoader && onStopLoader();
            setLoading(false);
            if (result.success) {
                onSuccess();
            } else {
                showErrorToast('Failed to update draft', 'update-draft-error');
            }
        }
    };
}
